export default [
  { // 通用宽带办理
    path: 'common/broadbandplace',
    name: 'commonBroadbandPlace',
    meta: {
      title: '订单下单 / 移动宽带下单预约',
      isRefresh: true
    },
    component: () => import('@/views/common/placeOrder/broadband')
  },
  { // 通用营销活动办理
    path: 'common/markingOrder',
    name: 'commonMarkingOrder',
    meta: {
      title: '订单下单 / 通用营销活动办理',
      isRefresh: true
    },
    component: () => import('@/views/common/placeOrder/markingOrder')
  },
  { // 通用号卡批量下单
    path: 'common/batchOrder',
    name: 'commonBatchOrder',
    meta: {
      title: '订单下单 / 通用号卡批量下单',
      isRefresh: true
    },
    component: () => import('@/views/common/placeOrder/batchOrder')
  },
  { // 通用宽带查询
    path: 'common/broadbandQuery',
    name: 'commonBroadbandQuery',
    meta: {
      title: '订单查询 / 宽带订单查询',
      isRefresh: true
    },
    component: () => import('@/views/common/orderquery/broadbandQuery')
  },
  { // 通用宽带查询
    path: 'common/tmminiappSettings',
    name: 'commonTMminiappSettings',
    meta: {
      title: '配置管理 / 店铺小程序配置',
      isRefresh: true
    },
    component: () => import('@/views/common/manage/tmminiappSettings')
  },
  { // 无订单号卡导入查询
    path: 'common/queryNoOrderTrack',
    name: 'CommonQueryNoOrderTrack',
    meta: {
      title: '订单查询 / 无订单物流导入查询',
      isRefresh: true
    },
    component: () => import('@/views/common/orderQuery/queryNoOrderTrack')
  },
  { // 号码黑名单
    path: 'common/blacklist',
    name: 'CommonBlackList',
    meta: {
      title: '系统配置 / 号码黑名单',
      isRefresh: true
    },
    component: () => import('@/views/common/manage/blacklist')
  },
  { // 合作公司管理
    path: 'common/cooperativeCompany',
    name: 'CommonCooperativeCompany',
    meta: {
      title: '系统配置 / 合作公司管理',
      isRefresh: true
    },
    component: () => import('@/views/common/manage/cooperativeCompany')
  },
  { // 合作公司管理
    path: 'common/cooperativeCompanyOrderQuery',
    name: 'CommonCooperativeCompanyOrderQuery',
    meta: {
      title: '订单查询 / 合作公司订单',
      isRefresh: true
    },
    component: () => import('@/views/common/orderquery/cooperativeCompanyOrderQuery')
  }
]


// WEBPACK FOOTER //
// ./src/router/common.route.js